import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import ErrorMessage from '../../components/Messages/ErrorMessage';
import Label from '../../components/Form/Label';
import Style from '../../styles/common';

const Container = styled('div')`
  margin-bottom: ${Style.SPACING.XL};
`;

const InputContainer = styled('div')`
  position: relative;
`;

const ErrorIcon = styled(FontAwesomeIcon)`
  color: ${Style.color.ERROR};
  font-size: 18px;
  margin-right: 15px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
`;

function Input(props) {
  const { error, touched } = props.meta;

  const errorMessage = error ? (
    <ErrorMessage>{error}</ErrorMessage>
  ) : null;

  const errorIcon = error ? (
    <ErrorIcon icon="exclamation-circle" />
  ) : null;

  const label = props.label ? (
    <Label htmlFor={props.input.name}>{props.label}</Label>
  ) : null;

  return (
    <Container>
      {label}
      <InputContainer>
        {props.children}
        {touched && error && errorIcon}
      </InputContainer>
      {touched && error && errorMessage}
    </Container>
  );
}

Input.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Input.defaultProps = {
  label: '',
  placeholder: '',
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Form/Input.js